export default __webpack_public_path__ + "static/media/farmer.d60b01bc.png";